export const updowncheck = new RegExp('(?=.*[a-z])(?=.*[A-Z]).{8,}');
export const strongRegex = new RegExp('(?=.*[0-9])(?=.*[!@#\$%\^&\*])');
